module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar shadowBottom darker bg-lightest d-flex justify-content-between align-items-center border-bottom-light"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-grow-1 h-100"
  }, [(_vm.showCompanyPicker) ? _c('companies') : _vm._e(), _vm._v(" "), (_vm.showSearch) ? _c('search') : _vm._e()], 1), _vm._v(" "), _c('user')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-007a69b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007a69b0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Bar.vue
// module id = 1421
// module chunks = 0